module.exports = __webpack_public_path__ + "static/media/inventor-logo.e82ed9c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/inventor-logo.png
// module id = 2302
// module chunks = 0